import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { ChannelDestination } from 'communication/Channel';
import { SignalTileStreamRequest } from 'widgets/signalTiles/signalTile/api/SignalTileStreamRequest';
import { WidgetType } from 'widgets/WidgetType';
import { ConfigSlice } from 'widgets/store/configuration/configSlice';
import {
    StreamRequestInfo,
    WidgetCustomStreamManager,
    WidgetCustomManagedStreamOptions,
    WidgetStreamByRequestUidConfig,
} from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import { WidgetStreamByRequestUidStreamManager } from 'widgets/streaming/widgetStreamManager/WidgetStreamByRequestUidStreamManager';
import State from 'store/State';
import { signalTileStreamRequestBuilders } from 'widgets/signalTiles/signalTile/state/stream/SignalTileStreamRequest';
import { WidgetId } from 'widgets/WidgetId';
import { DataServices } from 'store/Services';

export interface StreamConfigOptions {
    widgetType: WidgetType;
    startChannelDestination: ChannelDestination;
    configSlice: ConfigSlice<SignalTileConfigState>;
}

export function buildStreamConfig(options: StreamConfigOptions) {
    const { startChannelDestination, widgetType, configSlice } = options;
    const { initialConfigState } = configSlice;

    const {
        getSignalTileStreamRequestInfo,
        getSignalTileStreamRequestInfosForSymbols,
    } = signalTileStreamRequestBuilders(widgetType, initialConfigState);

    const signalTileWidgetStreamConfig: WidgetStreamByRequestUidConfig<SignalTileStreamRequest> =
        {
            channelDestination: startChannelDestination,
            managerFactory(
                options: WidgetCustomManagedStreamOptions
            ): WidgetCustomStreamManager {
                return new WidgetStreamByRequestUidStreamManager(options);
            },
            getWidgetStreamRequestInfo(
                state: State,
                services: DataServices,
                id: WidgetId
            ): Promise<StreamRequestInfo<SignalTileStreamRequest> | undefined> {
                return getSignalTileStreamRequestInfo(state, services, id);
            },
            getStreamRequestInfosForSymbols(
                state: State,
                services: DataServices,
                symbols: string[],
                config: unknown
            ): Promise<StreamRequestInfo<SignalTileStreamRequest>[]> {
                return getSignalTileStreamRequestInfosForSymbols(
                    state,
                    services,
                    symbols,
                    config as SignalTileConfigState
                );
            },
        };

    return signalTileWidgetStreamConfig;
}
